// import Header from "./Header";
import Footer from "./Footer";
import HeaderTest from "./HeaderTest";
function Layout(props) {
  return (
    <div>
      <HeaderTest />
      {props.children}
      <Footer />
    </div>
  );
}

export default Layout;
